<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" @select="handleSelect" id="elMenu">
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/daShaIndex">首页</el-menu-item>
        <el-menu-item index="/daSha/gasClamp">主缆进排气</el-menu-item>
        <el-submenu index="/daSha/prepStation1">
          <template slot="title">1号制备站</template>
          <el-menu-item index="/daSha/prepStation1/anchorAfan">1号制备站</el-menu-item>
          <el-menu-item index="/daSha/prepStation1/dehumidifierOne">1号除湿机</el-menu-item>
          <el-menu-item index="/daSha/prepStation1/dehumidifierTwo">2号除湿机</el-menu-item>
        </el-submenu>
        <el-submenu index="/daSha/prepStation2">
          <template slot="title">2号制备站</template>
          <el-menu-item index="/daSha/prepStation2/anchorAfan">2号制备站</el-menu-item>
          <el-menu-item index="/daSha/prepStation2/dehumidifierOne">1号除湿机</el-menu-item>
          <el-menu-item index="/daSha/prepStation2/dehumidifierTwo">2号除湿机</el-menu-item>
        </el-submenu>
        <el-submenu index="/daSha/prepStation3">
          <template slot="title">3号制备站</template>
          <el-menu-item index="/daSha/prepStation3/anchorAfan">3号制备站</el-menu-item>
          <el-menu-item index="/daSha/prepStation3/dehumidifierOne">1号除湿机</el-menu-item>
          <el-menu-item index="/daSha/prepStation3/dehumidifierTwo">2号除湿机</el-menu-item>
        </el-submenu>
        <el-submenu index="/daSha/prepStation4">
          <template slot="title">4号制备站</template>
          <el-menu-item index="/daSha/prepStation4/anchorAfan">4号制备站</el-menu-item>
          <el-menu-item index="/daSha/prepStation4/dehumidifierOne">1号除湿机</el-menu-item>
          <el-menu-item index="/daSha/prepStation4/dehumidifierTwo">2号除湿机</el-menu-item>
        </el-submenu>
        <el-submenu index="/daSha/prepStation5">
          <template slot="title">5号制备站</template>
          <el-menu-item index="/daSha/prepStation5/prepStationBig">5号制备站</el-menu-item>
          <el-menu-item index="/daSha/prepStation5/dehumidifierOne">1号除湿机</el-menu-item>
          <el-menu-item index="/daSha/prepStation5/dehumidifierTwo">2号除湿机</el-menu-item>
          <el-menu-item index="/daSha/prepStation5/dehumidifierThree">3号除湿机</el-menu-item>
          <el-menu-item index="/daSha/prepStation5/highPressureFan12">高压风机 1-2号</el-menu-item>
          <el-menu-item index="/daSha/prepStation5/highPressureFan34">高压风机 3-4号</el-menu-item>
        </el-submenu>
        <el-submenu index="/daSha/prepStation6">
          <template slot="title">6号制备站</template>
          <el-menu-item index="/daSha/prepStation6/prepStationBig">6号制备站</el-menu-item>
          <el-menu-item index="/daSha/prepStation6/dehumidifierOne">1号除湿机</el-menu-item>
          <el-menu-item index="/daSha/prepStation6/dehumidifierTwo">2号除湿机</el-menu-item>
          <el-menu-item index="/daSha/prepStation6/dehumidifierThree">3号除湿机</el-menu-item>
          <el-menu-item index="/daSha/prepStation6/highPressureFan12">高压风机 1-2号</el-menu-item>
          <el-menu-item index="/daSha/prepStation6/highPressureFan34">高压风机 3-4号</el-menu-item>
        </el-submenu>
        <el-menu-item index="/daSha/bridgeImg">全桥除湿总体布置图</el-menu-item>
        <el-submenu index=" /daSha/dataHistory?bridgeId=12d3dd46-152d-4fae-8b24-84dca74c4ce8&scenarioId=TBD">
          <template slot="title">数据历史</template>
          <el-menu-item index="/daSha/dataHistory?bridgeId=12d3dd46-152d-4fae-8b24-84dca74c4ce8&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/daSha/dataHistory?bridgeId=12d3dd46-152d-4fae-8b24-84dca74c4ce8"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="GUANGDONG" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
    </el-header>
    <el-main class="da-sha">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: "daSha",
  data() {
    return {
      bridgeId: "12d3dd46-152d-4fae-8b24-84dca74c4ce8",
      envInfo: {
        envId: "92f18b6f-b6f5-4fea-a8a2-5502b7fb5018",
        weather: "44fc48ab-5020-43fd-bd29-1d6b98e58552",
        humidity: "54f9505e-00c3-4360-930f-9d7f6b0b01d4",
        temperature: "d801ba8c-bfbf-46e9-8cf2-44de32161827",
      },
      id2Path: {
        "a1ffe3e8-6462-423b-af3f-b2259954e45e": "daSha/prepStation1",
        "d56a93e9-6708-4727-9569-e7332bb84728": "daSha/prepStation2",
        "922e3911-5b36-4bc3-8d57-cc0aca6aa459": "daSha/prepStation3",
        "070856c3-2a7a-49a7-849e-e9a4eaaa1ed0": "daSha/prepStation4",
        "f3fca3ce-b7fc-4c0d-8e42-7034df6965de": "daSha/prepStation5",
        "d3baafbf-08aa-4a4e-a1c5-7ed2906de97d": "daSha/prepStation6",
        "69259224-b365-4f62-ae96-e52fc31b2f00": "daSha/prepStation6",
        "25a74940-1a2a-41a4-aca0-c1a09f57e928": "daSha/gasClamp",
      },
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>

    <style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;
  display: none;
}
</style>